export const DEPT_PALETTE = [
  { accent: '#0d9488', ring: 'rgba(13,148,136,0.5)',  glow: 'rgba(13,148,136,0.15)',  badge: 'rgba(13,148,136,0.12)',  badgeText: '#5eead4', textLight: '#0f766e' },
  { accent: '#3b82f6', ring: 'rgba(59,130,246,0.5)',  glow: 'rgba(59,130,246,0.15)',  badge: 'rgba(59,130,246,0.12)',  badgeText: '#93c5fd', textLight: '#1d4ed8' },
  { accent: '#8b5cf6', ring: 'rgba(139,92,246,0.5)',  glow: 'rgba(139,92,246,0.15)',  badge: 'rgba(139,92,246,0.12)',  badgeText: '#c4b5fd', textLight: '#6d28d9' },
  { accent: '#ec4899', ring: 'rgba(236,72,153,0.5)',  glow: 'rgba(236,72,153,0.15)',  badge: 'rgba(236,72,153,0.12)',  badgeText: '#f9a8d4', textLight: '#be185d' },
  { accent: '#f59e0b', ring: 'rgba(245,158,11,0.5)',  glow: 'rgba(245,158,11,0.15)',  badge: 'rgba(245,158,11,0.12)',  badgeText: '#fcd34d', textLight: '#b45309' },
  { accent: '#10b981', ring: 'rgba(16,185,129,0.5)',  glow: 'rgba(16,185,129,0.15)',  badge: 'rgba(16,185,129,0.12)',  badgeText: '#6ee7b7', textLight: '#047857' },
  { accent: '#06b6d4', ring: 'rgba(6,182,212,0.5)',   glow: 'rgba(6,182,212,0.15)',   badge: 'rgba(6,182,212,0.12)',   badgeText: '#67e8f9', textLight: '#0e7490' },
  { accent: '#6366f1', ring: 'rgba(99,102,241,0.5)',  glow: 'rgba(99,102,241,0.15)',  badge: 'rgba(99,102,241,0.12)',  badgeText: '#a5b4fc', textLight: '#4338ca' },
];

// Reserved scheme for the C-suite — a rich gold that sets chiefs apart from
// the department-hashed palette above.
export const GOLD_SCHEME = {
  accent: '#d4af37',
  ring: 'rgba(212,175,55,0.55)',
  glow: 'rgba(212,175,55,0.18)',
  badge: 'rgba(212,175,55,0.16)',
  badgeText: '#fcd34d',
  textLight: '#a16207',
};

export function deptScheme(dept) {
  if (!dept) return DEPT_PALETTE[0];
  const hash = dept.split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  return DEPT_PALETTE[hash % DEPT_PALETTE.length];
}

// True for C-suite titles: "Chief Financial Officer", "Chief of Staff",
// "Chief Executive Officer", and the CEO's "Founder, Executive Officer".
export function isChiefTitle(jobTitle) {
  const t = jobTitle || '';
  return /\bchief\b/i.test(t) || /executive officer/i.test(t);
}

// True for the C-suite: anyone marked top-of-org (the CEO) or holding a chief title.
export function isExecutive(person) {
  return Boolean(person?.topOfOrg) || isChiefTitle(person?.jobTitle);
}

// Color scheme for a person: gold for the C-suite, otherwise the department color.
// Accepts anything carrying `jobTitle`, `department`, and optionally `topOfOrg`
// (employee record or org-chart node data).
export function schemeForEmployee(person) {
  if (isExecutive(person)) return GOLD_SCHEME;
  return deptScheme(person?.department);
}
